<template>
  <div class="form-group" :class="{'input-group': hasIcon}">

    <label v-if="label" class="control-label">
      <span v-if="required" class="required">*</span> {{label}}
    </label>

    <i v-if="help" class="fa fa-question-circle dynamic_tooltip" data-toggle="tooltip" data-html="true" data-placement="top" :title="help + (link? ' <a target=`_blank` href=' + link + '>more info</a>' : '')"></i>

    <div v-if="hasIcon" class="input-group">

      <div v-if="addonLeftIcon" class="input-group-prepend">
        <span class="input-group-text"> <i :class="addonLeftIcon"></i> </span>
      </div>

      <vue-tags-input v-if="tags" v-model="currentTag" :tags="addedTags" @tags-changed="tags => onNewTag(tags)" placeholder="Type a value and press comma or enter key to add to the list" :add-on-key="[13, ',']"/>
      <input v-else :type="concealed? 'password':'text'" :value="value" class="form-control"  v-bind="$attrs" v-on="listeners">

      <div v-if="concealable" class="input-group-append">
        <button class="btn conceal_button" type="button" @click="toggleShowAccessToken()" data-toggle="tooltip" data-placement="top" title="Show/hide token"><i :class="concealed? 'fa fa-eye' : 'fa fa-eye-slash'"/></button>
      </div>

      <div v-if="addonRightIcon" class="input-group-append">
        <span class="input-group-text"> <i :class="addonRightIcon"></i> </span>
      </div>

    </div>

    <vue-tags-input v-else-if="tags" if="tags" v-model="currentTag" :tags="addedTags" @tags-changed="tags => onNewTag(tags)" placeholder="Type a value and press comma or enter key to add to the list" :add-on-key="[13, ',']"/>
    <input v-else :value="value" class="form-control"  v-bind="$attrs" v-on="listeners">

  </div>
</template>

<script>
  import VueTagsInput from '@johmun/vue-tags-input';

  export default {

    name: "base-input",
    inheritAttrs: false,
    components: { VueTagsInput },

    props: {
      required: Boolean, // Shows an * on the label
      label: String, // Input label
      help: String, // Shows an ? icon with text
      link: String, // URL to more info on the ? icon
      addonLeftIcon: String, // Input icon on the left
      value: [String, Number], // Input value
      addonRightIcon: String, // Input icon on the right
      concealable: Boolean, // Concealable text
      tags: Boolean, // Create tags from input content
    },

    data() {
      return {
        concealed: this.concealable,
        currentTag: '',
        addedTags: (this.tags && this.value)? this.value.split(',').map(tag => ({"text": tag, "tiClasses": ["ti-valid"]})) : []
      }
    },

    computed: {
      hasIcon() {
        return this.addonLeftIcon || this.addonRightIcon || this.concealable
      },
      listeners() {
        return {
          ...this.$listeners,
          input: this.onInput
        }
      }
    },

    methods: {
      onNewTag(tags){
        this.addedTags = tags
        this.$emit('input', tags.map(tag=>tag.text).join(','))
      },
      onInput(event) {
        this.$emit('input', event.target.value)
      },
      toggleShowAccessToken(){
        this.concealed = !this.concealed
      }
    },
  }
</script>

<style scoped>
  .required{
    color: crimson;
  }
  .fa-question-circle{
    padding-left: 0.5rem;
    color: #517aa1;
    cursor: help;
  }
  .input-group .form-control:last-child{
    border-left: solid 1px #E3E3E3;
  }
  .input-group .form-control:last-child:focus{
    border-left: solid 1px #AAAAAA;
  }
  .conceal_button,
  .conceal_button:focus{
    height: 40px;
    border: 1px solid #A3A3A3;
    color: black;
    background-color: #F5F5F5;
    transform: translate(1px, 0);
  }
  .conceal_button:hover{
    background-color: #ededce;
    color: black;
  }
</style>
<style>
  .vue-tags-input{
    max-width: none !important;
  }
  .vue-tags-input .ti-input {
    border: 1px solid #E3E3E3 !important;
    border-radius: 4px;
  }
  .vue-tags-input.ti-focus .ti-input{
    border: 1px solid #AAAAAA !important;
  }
  .ti-new-tag-input-wrapper input::placeholder {
    color: #D5D5D5;
  }
  .vue-tags-input .ti-tag {
    background: #2f99c6;
    border-radius: 4px;
  }
</style>
